import { useEffect } from 'react'

const PIXEL_ID = '931401796468747'

declare global {
  interface Window {
    fbq?: any
    _fbq?: unknown
  }
}

/**
 * Injects the official Meta (Facebook) Pixel base code once and fires a
 * single PageView event. Safe against double-injection (e.g. React strict mode)
 * and against documents that have no pre-existing <script> tag.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return

    // Set up the fbq command queue (only once).
    if (!window.fbq) {
      const fbq: any = function (...args: unknown[]) {
        fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args)
      }
      if (!window._fbq) window._fbq = fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq

      // Load the Meta Pixel script by appending to <head> — this avoids relying
      // on an existing <script> tag (the original snippet crashes when none exists).
      if (!document.getElementById('meta-pixel-script')) {
        const script = document.createElement('script')
        script.id = 'meta-pixel-script'
        script.async = true
        script.src = 'https://connect.facebook.net/en_US/fbevents.js'
        ;(document.head || document.documentElement).appendChild(script)
      }

      window.fbq('init', PIXEL_ID)
    }

    window.fbq('track', 'PageView')
  }, [])
}
